import { IResultData } from "@/domain/entities/shared/result";
import { ISystemCode } from "@/domain/entities/system";
import {
  ICustomCode,
  ICustomCodeCollection,
} from "@/domain/entities/system/customCode.types";
import TYPES from "@/ioc/identifiers";
import { container } from "@/ioc/inversify.config";
import { ISystemRepository } from "@/repositories/system/systemRepository.types";
import { HynixCoordinate } from "@/types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { defineStore } from "pinia";

interface ISystemState {
  campusList: ICustomCode[];
  campusCoordinateList: HynixCoordinate[];
}

const systemRepository = () => {
  return container.get<ISystemRepository>(TYPES.ISystemRepository);
};
export const useSystemStore = defineStore("system", {
  state: (): ISystemState => {
    return {
      campusList: [],
      campusCoordinateList: [],
    };
  },
  getters: {},
  actions: {
    updateCampusList(list: ICustomCode[]) {
      this.campusList = list;
    },

    updateCampusCoordinateList(list: ICustomCode[]) {
      this.campusCoordinateList = list.map((customCode) => {
        const coordinate: HynixCoordinate = {
          campusName: customCode.name,
          lat: customCode.props?.latitude ?? -1,
          lng: customCode.props?.longitude ?? -1,
          radiusMeter: customCode.props?.busLocationSearchRadiusM ?? 1000,
        };
        return coordinate;
      });
    },

    async getSystemCodes(
      codeGroup?: string,
      parentCodes?: string
    ): Promise<IResultData<ISystemCode[]>> {
      const systemCodeResult: IResultData<ISystemCode[]> = {
        isSuccess: false,
      };

      await systemRepository()
        .getSystemCodes(codeGroup, parentCodes)
        .then((result) => {
          result
            .map((systemCodes) => {
              systemCodeResult.isSuccess = true;
              systemCodeResult.data = systemCodes;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(systemCodeResult, error);
              systemCodeResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          systemCodeResult.errorMessage = error.message;
        });

      return systemCodeResult;
    },

    async getCustomCodes(
      codeGroup?: string,
      parentCode?: string,
      parentUid?: string
    ): Promise<IResultData<ICustomCodeCollection>> {
      const customCodeResult: IResultData<ICustomCodeCollection> = {
        isSuccess: false,
      };

      await systemRepository()
        .getCustomCodes(codeGroup, parentCode, parentUid)
        .then((result) => {
          result
            .map((resData) => {
              customCodeResult.isSuccess = true;
              customCodeResult.data = resData;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(customCodeResult, error);
              customCodeResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          customCodeResult.errorMessage = error.message;
        });

      return customCodeResult;
    },
  },
});
